import { Skeleton } from '@sixui/ui';
import { colorSchemeTokens } from '@sixui/ui/themes/base/colorScheme.stylex';
import { shapeTokens } from '@sixui/ui/themes/base/shape.stylex';
import stylex from '@stylexjs/stylex';

import type { IContainerProps } from '~/components/utils/Container';

type IThumbnailSize = 'sm' | 'md' | 'lg';

export type IThumbnailProps = IContainerProps & {
  url?: string;
  loading?: boolean;
  children?: React.ReactNode;
  size?: IThumbnailSize;
};

const styles = stylex.create({
  host: (size: number) => ({
    position: 'relative',
    borderRadius: shapeTokens.corner$sm,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexGrow: 0,
    flexShrink: 0,
    width: size,
    height: size,
    overflow: 'hidden',
    backgroundColor: colorSchemeTokens.surfaceContainerHighest,
  }),
  host$image: (src: string) => ({
    objectFit: 'cover',
    backgroundColor: 'unset',
    backgroundImage: `url(${src})`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
  }),
});

const sizeInPixels: Record<IThumbnailSize, number> = {
  sm: 32,
  md: 40,
  lg: 64,
};

export const Thumbnail: React.FC<IThumbnailProps> = (props) => {
  const { sx, url, loading, size = 'md', children } = props;

  return (
    <div
      {...stylex.props(
        styles.host(sizeInPixels[size]),
        url ? styles.host$image(url) : undefined,
        sx,
      )}
    >
      <Skeleton variant="overlay" loaded={!loading}>
        {children}
      </Skeleton>
    </div>
  );
};
